export const BENEFICIARY_DATA_REQUEST = 'BENEFICIARY_DATA_REQUEST';
export const BENEFICIARY_DATA_SUCCESS = 'BENEFICIARY_DATA_SUCCESS';
export const BENEFICIARY_DATA_FAIL = 'BENEFICIARY_DATA_FAIL';
